import React, { Component } from 'react';
import _ from 'lodash';
import Fuse from 'fuse.js';

import ParkinglocationPlacesTable from '../components/ParkinglocationPlacesTable';
import ParkinglocationPlacesModel from '../components/ParkinglocationPlacesModel';
import ParkinglocationPlacesForm from '../components/ParkinglocationPlacesForm';
import ParkinglocationSelect from '../components/ParkinglocationSelect';
import UserModel from '../components/UserModel';

import { Layout, Button, Row, Col, Input, Icon, DatePicker, message } from 'antd';

class SettingsParkinglocationPlacesScreen extends Component {

  fuseOptions = {
    shouldSort: true,
    includeScore: true,
    threshold: 0.1,
    location: 0,
    distance: 100,
    maxPatternLength: 32,
    minMatchCharLength: 2,
    keys: [
      "placeID"
    ]
  }

  state = {
    dataLoading: false,
    dataAll: [],
    data: [],
    parkinglocationPlacesFormModalVisible: false,
    parkinglocation: null,
    date: null,
  }

  loadData(parkinglocation) {
    if (parkinglocation) {
      this.setState({
        dataLoading: true
      });
      ParkinglocationPlacesModel.getAll(parkinglocation)
        .then(data => {
          this.setState({
            dataLoading: false,
            dataAll: data,
            data: data,
          });
        })
        .catch(err => {
          message.warning('Pakovací místa se nepodařilo načíst!');
          this.setState({
            dataLoading: false,
          });
        });
    } else {
      message.warning('Zvolte prosím lokalitu!');
    }
  }

  onSearch(searchText) {
    const dataAll = this.state.dataAll;
    this.setState({
      dataLoading: true
    })
    if (searchText) {
      let fuse = new Fuse(dataAll, this.fuseOptions);
      let results = fuse.search(searchText);
      results = results.map((result) => {
        return result.item;
      });
      this.setState({
        dataLoading: false,
        data: results
      });
    } else {
      this.setState({
        dataLoading: false,
        data: dataAll
      });
    }
  }

  render() {
    return (
      <Layout.Content style={{ margin: '24px 16px 0', minHeight: 'auto' }}>
        <div style={{ padding: 24, background: '#fff', minHeight: 360 }}>
          <h2>Systém - Parkovací místa</h2>
          <div style={{ marginBottom: '20px' }}>
            <Row>
              <Col span={20}>
                <ParkinglocationSelect
                  onChange={(value) => {
                    this.setState({ parkinglocation: value });
                    this.loadData(value, this.state.date);
                  }}
                  style={{ width: 300 }} />
                {' '}
                <Input.Search
                  placeholder="Hledat"
                  onSearch={this.onSearch.bind(this)}
                  style={{ width: 300 }} />
              </Col>
              <Col span={4} offset={0} style={{ textAlign: 'right' }}>
                <Button type="default" onClick={() => { this.loadData(this.state.parkinglocation) }} style={{ marginRight: 10 }}>
                  <Icon type="sync" />
                </Button>
                {UserModel.isInRoles(['ADMIN', 'CORE_PARKINGLOCATIONS_PLACES_WRITE'])
                  ? <Button type="default" onClick={() => { this.setState({ parkinglocationPlacesFormModalVisible: true }) }}>Nové místo</Button>
                  : null}
              </Col>
            </Row>
          </div>
          <ParkinglocationPlacesForm
            type="modal"
            modalVisible={this.state.parkinglocationPlacesFormModalVisible}
            onModalCancel={(form) => {
              form.resetFields();
              this.setState({ parkinglocationPlacesFormModalVisible: false });
            }}
            onSuccess={(form, values) => {              
              let parkingLocationId = values.parkingLocationId;
              delete values['parkingLocationId'];
              ParkinglocationPlacesModel.create(parkingLocationId, values)
                .then(() => {
                  form.resetFields(['placeID']);
                  if (this.state.parkinglocation) {
                    this.loadData(this.state.parkinglocation);
                  }
                })
                .catch((err) => {
                  message.warning('Data se nepodařilo uložit. Prosím kontaktujte správce systému!');
                });
            }} />
          <ParkinglocationPlacesTable
            data={this.state.data}
            loading={this.state.dataLoading}
            onRemoveRow={(id) => {
              ParkinglocationPlacesModel.remove(this.state.parkinglocation, id)
                .then(() => {
                  this.loadData(this.state.parkinglocation);
                  message.success('Parkovací místo bylo odstraněno')
                })
                .catch(() => {
                  message.error('Parkovací místo se nepodařilo smazat!');
                })
            }}
          />
        </div>
      </Layout.Content>
    );
  }
}

export default SettingsParkinglocationPlacesScreen;



// WEBPACK FOOTER //
// ./src/screens/SettingsParkinglocationPlacesScreen.js